import { FilterOption, UserSearch } from '@/models/gen/graphql';

import { ReactElement } from 'react';
import { Select } from 'antd';
import { getAirportGroups } from '@/api/services/filters/airportGroups';
import { getImportProvider } from '@/api/services/filters/importProvider';
import { getSelectUserFilter } from '@/api/services/users/searchUsers';

const buildOptions = (options: FilterOption[]): ReactElement[] =>
  options
    .sort((a, b) => (a.values?.length > 0 ? 1 : a.displayName.localeCompare(b.displayName)))
    .map(
      ({ id, displayName, values }: FilterOption): ReactElement => (
        <Select.Option key={id} value={values?.length > 0 ? values : id}>
          {displayName}
        </Select.Option>
      )
    );
export const fetchUsers = async (airports: string[] = [], ...queries: UserSearch[]): Promise<ReactElement[]> => {
  try {
    const res = await getSelectUserFilter(airports || [], ...queries);
    return buildOptions((res || []).map(({ id, fullName }) => ({ id, displayName: fullName })));
  } catch (err) {
    console.error('Error fetching users for addon filters', err);
    return [];
  }
};

export const fetchProviders = async (): Promise<ReactElement[]> => {
  try {
    const res = await getImportProvider();
    return buildOptions(res || []);
  } catch (err) {
    console.error('Error fetching providers for addon filters', err);
    return [];
  }
};

export const fetchAirportGroups = async (): Promise<ReactElement[]> => {
  try {
    const res = await getAirportGroups();
    return buildOptions(res || []);
  } catch (err) {
    console.error('Error fetching airport groups for addon filters', err);
    return [];
  }
};
